import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DocumentService } from '../../service/document.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Message } from 'primeng/components/common/api';
import { ActivatedRoute, Router } from '@angular/router';
import { AppSettings } from '../../shared/AppSettings';

@Component({
  selector: 'app-document-file-preview',
  templateUrl: './document-file-preview.component.html',
  styleUrls: ['./document-file-preview.component.css']
})
export class DocumentFilePreviewComponent implements OnInit {

  @Input() DocumentId?: number;
  @Input() DocumentLink: string;
  @Input() RawFileName: string;

  documentFile: any;
  currentImage: number = null;
  showDownloadButton: boolean = false;
  showDownloadWarning: boolean = false;

  msgs: Message[] = [];

  rotateAngles: any[] = ['rotated0', 'rotated90', 'rotated180', 'rotated270'];
  rotateAngleCurrent: number = 0;


  constructor(private documentService: DocumentService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.getdocumentFile();
  }

   getdocumentFile()
  {
    // let orderId = this.route.snapshot.paramMap.get('order');
     let documentFilterByDocumentIdEncoded = {
       DocumentIdLink: this.DocumentLink,    
       DocumentId: this.DocumentId    
    };
    
     this.documentService.getDocumentFileStream(documentFilterByDocumentIdEncoded).subscribe((result: any) => {
       this.documentFile = result;
      this.currentImage = 0;
      this.showDownloadButton = true;
      if (this.documentFile.FileStreams) {
        this.showDownloadWarning = false;
      } else {
        this.showDownloadWarning = true;
      }
        //console.log(this.documentFile);
    },
      (err: HttpErrorResponse) => {
        let errMessage = (err.error && err.error.ExceptionMessage) ? err.error.ExceptionMessage : 'תקלה בקבלת נתונים ';
        this.documentFile = null;
        this.showDownloadButton = true;
        this.showDownloadWarning = true;
        this.showMessage('error', '', errMessage);
      });
  }

  setPage(i) {
    this.currentImage = i;
  }
  download() {
    let documentFilterByDocumentIdEncoded = {
      DocumentIdLink: this.DocumentLink,    
      DocumentId: this.DocumentId    
    };
    this.documentService.getDocumentFile(documentFilterByDocumentIdEncoded).subscribe(result => {
      let fileName;
      if (this.documentFile && this.documentFile.FileName && this.documentFile.FileName  != '') {
        fileName = this.documentFile.FileName;
      } else {
        fileName = this.RawFileName;
      }
      window.URL.createObjectURL(new Blob([result], { type: 'application/octet-stream' }));
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(result, fileName);
      }
      let url = window.URL.createObjectURL(result)
      let link = document.createElement('a');
      link.href = url;
      link.download = `${fileName}`;
      link.click();
    },
      (err: HttpErrorResponse) => {
        //let errMessage = (err.error && err.error.ExceptionMessage) ? err.error.ExceptionMessage : 'תקלה בהורדת קובץ ';
        //this.showMessage('error', '', errMessage);
        this.showMessage('error', '', 'תקלה בהורדת קובץ');
      });
  }


  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  showSuccess() {
    this.msgs = [];
    this.msgs.push({ severity: 'success', summary: '', detail: ' העדכון נשמר בהצלחה' });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' שגיאה בעדכון' });
  }

  rotate(dir) {
    if (this.rotateAngleCurrent == 0 && dir == -1) {
      this.rotateAngleCurrent = 4;
    }
    this.rotateAngleCurrent = (this.rotateAngleCurrent + dir) % 4;
  }

}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/document/document-file-preview/document-file-preview.component.ts